<div class="wrapper-loader-exchange" *ngIf="isLoadingExchange$ | async"></div>

<app-flight-results-mobile
  *ngIf="isMobile$ | async"
  [disabledScroll]="disableScroll"
  [exchangeData]="exchangeData"
  [params]="params"
  [isExchangeSearch]="true">
</app-flight-results-mobile>

<app-flight-results-desktop
  *ngIf="(isMobile$ | async) === false"
  [disabledScroll]="disableScroll"
  [exchangeData]="exchangeData"
  [isExchangeSearch]="true">
</app-flight-results-desktop>

<ng-container *ngIf="isMobile$ | async">
  <router-outlet name="confirm" (deactivate)='onDeactivate()'></router-outlet>
</ng-container>
